<template>
  <b-card no-body class="h-100 bg-dark-navy custom border-0" footer-class="py-2" v-if="current">
    <template v-slot:header>
      <b-row>
        <b-col>
          <h6 class="color-white pt-1 mb-0">{{ current.submission.patient.demographics.name || current.submission.patient.identifier }}</h6>
        </b-col>
        <b-col cols="2" class="text-right">
          <b-button-group size="sm">
            <b-button class="font-weight-400 bg-transparent" v-b-modal.modal-fullscreen>
              Fullscreen <font-awesome-icon icon="expand-arrows-alt" class="ml-1"></font-awesome-icon>
            </b-button>
          </b-button-group>
          <b-button-group size="sm">
            <b-button class="font-weight-400 bg-transparent" v-b-modal.modal-feedback>
              <font-awesome-icon icon="comment-dots"></font-awesome-icon>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </template>
    <b-card-body class="h-100 p-0">
      <div class="p-3">
        <b-row>
          <b-col>
            <b-alert class="float-alert" :show="true" variant="primary">
              <b>Not for Diagnostic Use -- For Prioritization Only</b>
            </b-alert>
            <lightbox :album="current.submission.patient.identifier" :src="originalImage(current.submission)" caption="Original Image">
              <img class="img img-fluid w-100" :src="originalImage(current.submission)" />
            </lightbox>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
    <template v-slot:footer>
      <b-row>
        <b-col cols="12" class="text-center">
          <b-badge pill class="indicator high my-0 mx-2 px-3" v-if="conclusion">
            <font-awesome-icon icon="circle" size="lg"></font-awesome-icon> {{ conclusion }}
          </b-badge>
        </b-col>
      </b-row>
    </template>

    <feedback :current="current"></feedback>
    <full-screen :current="current"></full-screen>
  </b-card>
</template>

<style>
.float-alert {
  position: absolute;
  top: -0.5rem;
  left: 15rem;
  right: 15rem;
  text-align: center;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  opacity: 0.75;
  font-size: 12px;
}
</style>

<script>
import Lightbox from 'vue-lightbox'
import { apiRoute } from './../../../helpers'

import Feedback from './Feedback'
import FullScreen from './FullScreen'

export default {
  components: {
    Feedback,
    FullScreen,
    Lightbox
  },
  data () {
    return {
      current: null,
      selectedHeatmap: null,
      key: 1
    }
  },
  props: {
    selected: {
      type: Object,
      default: null
    }
  },
  computed: {
    selectedImage () {
      if (this.selectedHeatmap) {
        return this.current.heatmaps.find(heatmap => heatmap.filename === this.selectedHeatmap)
      } else {
        return null
      }
    },
    filteredList () {
      if (this.current.analysis.pathologies && this.current.analysis.pathologies.length > 0) {
        const _list = this.current.analysis.pathologies.filter(_pathology => _pathology.name !== 'Thoracic' && _pathology.name !== 'Cardio')
        return _list
      } else {
        return []
      }
    },
    isPleural () {
      if (this.selected && this.selected.submission) {
        const _attachments = this.selected.submission.attachments
        if (_attachments && Array.isArray(_attachments) && _attachments.length > 0) {
          const _attachment = _attachments[0]
          if (_attachment && _attachment.response && _attachment.response.labels && Array.isArray(_attachment.response.labels) && _attachment.response.labels.length > 0) {
            const _pathologies = _attachment.response.labels[0].pathologies
            if (_pathologies && Array.isArray(_pathologies) && _pathologies.length > 0) {
              return _pathologies.filter(_pathology => _pathology.predicted_diagnosis === 'pleuraleffusion').length > 0
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isPneumo () {
      if (this.selected && this.selected.submission) {
        const _attachments = this.selected.submission.attachments
        if (_attachments && Array.isArray(_attachments) && _attachments.length > 0) {
          const _attachment = _attachments[0]
          if (_attachment && _attachment.response && _attachment.response.labels && Array.isArray(_attachment.response.labels) && _attachment.response.labels.length > 0) {
            const _pathologies = _attachment.response.labels[0].pathologies
            if (_pathologies && Array.isArray(_pathologies) && _pathologies.length > 0) {
              return _pathologies.filter(_pathology => _pathology.predicted_diagnosis === 'pneumothorax').length > 0
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    conclusion () {
      if (this.isPleural) {
        if (this.isPneumo) {
          return 'Suspected Pleural Effusion and Pneumothorax'
        } else {
          return 'Suspected Pleural Effusion'
        }
      } else if (this.isPneumo) {
        return 'Suspected Pneumothorax'
      } else {
        return null
      }
    }
  },
  created () {
    this.current = null
  },
  mounted () {
    if (this.selected) {
      this.current = this.selected
    }
  },
  methods: {
    setHeatmap: function (name) {
      this.selectedHeatmap = name
    },
    getConclusion: function (name) {
      if (name.indexOf('high') > -1) {
        return ''
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return ''
      } else if (name.indexOf('other') > -1) {
        return ''
      } else {
        return ''
      }
    },
    getIcon: function (name) {
      if (name.indexOf('high') > -1) {
        return 'circle'
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return 'circle'
      } else {
        return 'heartbeat'
      }
    },
    getIndicator: function (name) {
      if (name.indexOf('high') > -1) {
        return 'high'
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return 'high'
      } else {
        return 'nothing'
      }
    },
    originalImage: function (result) {
      if (result) {
        if (result.attachments[0].path.indexOf('http') === -1) {
          return apiRoute() + result.attachments[0].path
        } else {
          return result.attachments[0].path
        }
      } else {
        return null
      }
    }
  }
}
</script>
